// KaTeX 렌더링 디렉티브 (v-katex)
// v-html 로 주입된 답안/채점기준표 등의 HTML 안에 들어있는 LaTeX($...$, \(...\) 등)를
// KaTeX 로 렌더링한다. 이미 katex 마크업이 들어있는 경우는 katex CSS 로 표현되며,
// 텍스트로 들어온 수식은 아래 renderMathInElement 로 변환된다.
import renderMathInElement from "katex/dist/contrib/auto-render";

const renderKatex = (el) => {
  if (!el) {
    return;
  }

  try {
    renderMathInElement(el, {
      delimiters: [
        { left: "$$", right: "$$", display: true },
        { left: "\\[", right: "\\]", display: true },
        { left: "\\(", right: "\\)", display: false },
        { left: "$", right: "$", display: false },
      ],
      throwOnError: false,
      ignoredTags: ["script", "noscript", "style", "textarea", "pre", "code"],
    });
  } catch (error) {
    // 수식 파싱 실패는 원문 유지
  }
};

export const katexDirective = {
  mounted(el) {
    renderKatex(el);
  },
  updated(el) {
    renderKatex(el);
  },
};

export default katexDirective;
